export default {
  cannot_bid_to_fixed_sale: 'cannot bid to fixed sale',
  must_raise_the_bid_price_higher_than_the_current_bidder:
    'must raise the bid price higher than the current bidder',
  invalid_credit_card:
    '決済に失敗しました。登録クレジットカード情報をご確認ください。',
  destination_not_found: 'destination_not_found',
  shipping_address_is_incorrect: 'shipping address is incorrect',
};
